export default __webpack_public_path__ + "road-perspective.png";